import { render, staticRenderFns } from "./addGroup.vue?vue&type=template&id=fada3780&scoped=true&"
import script from "./addGroup.vue?vue&type=script&lang=js&"
export * from "./addGroup.vue?vue&type=script&lang=js&"
import style0 from "./addGroup.vue?vue&type=style&index=0&id=fada3780&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fada3780",
  null
  
)

export default component.exports